import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { BasketModule } from '@vueling-ng/vy-ds/src/lib/components/composed/basket';
import { CardFeaturedModule } from '@vueling-ng/vy-ds/src/lib/components/composed/card-featured';
import { CardQuickAccessComponent } from '@vueling-ng/vy-ds/src/lib/components/composed/card-quick-access';
import { FlightSummaryModule } from '@vueling-ng/vy-ds/src/lib/components/composed/flight-summary';
import { AccordionModule } from '@vueling-ng/vy-ds/src/lib/components/globals/accordion';
import { AlertMessageModule } from '@vueling-ng/vy-ds/src/lib/components/globals/alert-message';
import { AvatarNameModule } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar-name';
import { BadgeModule } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';
import { BoxModule } from '@vueling-ng/vy-ds/src/lib/components/globals/box';
import { BreadcrumbComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/breadcrumb';
import { ButtonModule } from '@vueling-ng/vy-ds/src/lib/components/globals/button';
import { FlightJourneyComponent } from '@vueling-ng/vy-ds/src/lib/components/globals/flight-journey';
import { IconModule } from '@vueling-ng/vy-ds/src/lib/components/globals/icon';
import { IconTextModule } from '@vueling-ng/vy-ds/src/lib/components/globals/icon-text';
import { ListModule } from '@vueling-ng/vy-ds/src/lib/components/globals/list';
import { VyModalService } from '@vueling-ng/vy-ds/src/lib/components/globals/modal';
import { ProcessMessageModule } from '@vueling-ng/vy-ds/src/lib/components/globals/process-message';
import { RouteTitleModule } from '@vueling-ng/vy-ds/src/lib/components/globals/route-title';
import { DateFormatModule } from '../../shared/pipes/date-format.module';
import { FormatHoursPipe } from '../../shared/pipes/format-hours.pipe';
import { BookingDetailComponent } from './booking-detail.component';
import { ContactInformationComponent } from './components/contact-information/contact-information.component';
import { FlightDetailComponent } from './components/flight-detail/flight-detail.component';
import { FlightJourneysSummaryComponent } from './components/flight-journeys-summary/flight-journeys-summary.component';
import { FlightSummaryHeaderComponent } from './components/flight-summary-header/flight-summary-header.component';
import { BookingServicesComponent } from './components/pax-services-and-contact-information/booking-services/booking-services.component';
import { PaxServicesAndContactInformationComponent } from './components/pax-services-and-contact-information/pax-services-and-contact-information.component';
import { PaymentDetailComponent } from './components/pax-services-and-contact-information/payment-detail/payment-detail.component';
import { SharedBookingServicesComponent } from './components/pax-services-and-contact-information/shared-booking-services/shared-booking-services.component';

@NgModule({
  declarations: [
    BookingDetailComponent,
    FlightSummaryHeaderComponent,
    FlightDetailComponent,
    FlightJourneysSummaryComponent,
    PaxServicesAndContactInformationComponent,
    SharedBookingServicesComponent,
    PaymentDetailComponent,
    BookingServicesComponent,
    ContactInformationComponent
  ],
  imports: [
    CommonModule,
    IconTextModule,
    BadgeModule,
    TranslateModule,
    RouteTitleModule,
    FlightJourneyComponent,
    ProcessMessageModule,
    AccordionModule,
    FlightSummaryModule,
    DateFormatModule,
    BoxModule,
    ListModule,
    IconModule,
    BasketModule,
    DateFormatModule,
    AvatarNameModule,
    BreadcrumbComponent,
    CardQuickAccessComponent,
    CardFeaturedModule,
    ButtonModule,
    AlertMessageModule
  ],
  providers: [DatePipe, TranslatePipe, FormatHoursPipe, VyModalService],
  exports: [BookingDetailComponent, FlightDetailComponent]
})
export class BookingDetailModule {}
